exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-success.checkmark-icon {\n  color: #5578eb !important;\n}", ""]);

// exports
